// extracted by mini-css-extract-plugin
export default {"contentWrap":"OnboardApplySuccess_contentWrap__tS7KK","content":"OnboardApplySuccess_content__Wyf14"};